import Icon from '@assets/icons/tisit_logo_full.svg'

export const CustomLoader = () => {
	return (
		<div
			role='status'
			aria-label='Загрузка'
			aria-busy='true'
			className='fixed inset-0 z-[999] flex min-h-dvh w-full items-center justify-center bg-white'>
			{/* Define keyframes and a small helper class locally so the logo fades:
			    0% -> opacity 10%, 50% -> 90%, 100% -> 10% */}
			<style>{`
				@keyframes logoFade {
					0% { opacity: 0.1; }
					50% { opacity: 0.9; }
					100% { opacity: 0.1; }
				}
				.logo-fade {
					animation: logoFade 5s ease-in-out infinite;
				}
				@media (prefers-reduced-motion: reduce) {
					.logo-fade {
						animation: none;
						opacity: 0.9;
					}
				}
			`}</style>

			<img
				src={Icon}
				alt='Tisit Logo'
				className='logo-fade block h-auto w-[165px] max-w-[54vw]'
			/>
		</div>
	)
}
